import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, ContentrArea } from '@ttstr/components';

const B2b: React.FC = () => {
  return (
    <article className="my-5">
      <Helmet>
        <body className="b2b-page" />
        <title>{'B2B'}</title>
      </Helmet>
      <Container>
        <ContentrArea id="main" />
      </Container>
    </article>
  );
};

export default React.memo(B2b);
